import { useSelector } from 'react-redux';
import { RootState } from '../../Store';
import { PropertiesState } from '../../Store/Properties/state';
import { Property } from '../../Interface/Response/ProductProperty/List/PropertiesByCategory';

const useGetProperties = (): Property[] => {
    const { properties } = useSelector<RootState, PropertiesState>(state => state.properties);

    return properties;
}

export default useGetProperties;
